import styled from 'styled-components/macro'
import { rem, media } from '../../utils/styles'

const ContentWrapper = styled.div`
  margin: ${rem(20)} 0 0;

  ${media('tablet')`
    margin: ${rem(40)} ${rem(40)} 0;
  `}

  ${media('desktop')`
    margin: ${rem(70)} ${rem(75)} 0;
  `}
`

export default ContentWrapper
